import { Calendar, Columns, X } from 'lucide-react';
import React, { useCallback, useEffect, useState } from 'react';

const events = [
  { id: 1, name: "Independence", date: "2023-04-15" },
  { id: 2, name: "Student-Week", date: "2023-06-22" },
  { id: 3, name: "Graduations", date: "2023-08-10" },
  { id: 4, name: "Sports", date: "2023-10-05" },
  { id: 6, name: "Trailblazers", date: "2024-05-20" },
  { id: 7, name: "Explorations", date: "2024-03-08" },
];


const photos = [
  // Independence Celebration (event id 1)
  { id: 1, src: "https://i.ibb.co/NswsL8x/7th-executive-at-highcommisioner.jpg", alt: "Independence", type: "landscape", eventId: 1 },
  { id: 2, src: "https://i.ibb.co/pzz97mB/59th-group-manav.jpg", alt: "Independence", type: "landscape", eventId: 1 },
  { id: 3, src: "https://i.ibb.co/syJjLfd/adama-present-hc.jpg", alt: "Independence photo", type: "landscape", eventId: 1 },
  { id: 4, src: "https://i.ibb.co/jLv1WYm/depity-with-dawda.jpg", alt: "Independence", type: "landscape", eventId: 1 },
  { id: 5, src: "https://i.ibb.co/wzsrhdk/Gam-ind-grad-with-fift-presiden.jpg", alt: "Independence", type: "landscape", eventId: 1 },
  { id: 6, src: "https://i.ibb.co/mcTzD49/gam-ind-ladies-manav.jpg", alt: "Independence", type: "landscape", eventId: 1 },
  { id: 7, src: "https://i.ibb.co/KqkDz3P/gujurat-flag-field.jpg", alt: "Independence", type: "landscape", eventId: 1 },
  { id: 8, src: "https://i.ibb.co/wWxtKvq/high-commisioner-with-adama.jpg", alt: "Independence", type: "landscape", eventId: 1 },
  { id: 9, src: "https://i.ibb.co/tPrMYyS/independe-at-manav.jpg", alt: "Independence", type: "landscape", eventId: 1 },
  { id: 10, src: "https://i.ibb.co/VD9tsVb/manav-highcom-Gam-ind.jpg", alt: "Independence", type: "landscape", eventId: 1 },
  { id: 12, src: "https://i.ibb.co/JKVnpSD/sankung-hightable.jpg", alt: "Independence", type: "landscape", eventId: 1 },
  { id: 13, src: "https://i.ibb.co/gZ4BXQf/swareh.jpg", alt: "Independence", type: "landscape", eventId: 1 },
  { id: 14, src: "https://i.ibb.co/TgGxF0Q/njies-cul.jpg", alt: "Independence", type: "landscape", eventId: 1 },

  // Gam-Ind fest (event id 1)
  { id: 61, src: "https://i.ibb.co/Dkfpdt6/high-personel-flower.jpg", alt: "Cultural", type: "all", eventId: 1 },
  { id: 62, src: "https://i.ibb.co/kGCQ05w/Hcommisoner-lights.jpg", alt: "Cultural", type: "all", eventId: 1 },
  { id: 63, src: "https://i.ibb.co/c2jhTZk/vizag-family.jpg", alt: "Cultural", type: "all", eventId: 1 },
  { id: 64, src: "https://i.ibb.co/rF305j8/mbow-haftan.jpg", alt: "Cultural", type: "all", eventId: 1 },
  { id: 65, src: "https://i.ibb.co/pKhzRbw/Ghigh-Comissioner-agreement.jpg", alt: "International", type: "all", eventId: 1 },
  { id: 66, src: "https://i.ibb.co/TcYSzC4/ghana-sis.jpg", alt: "Cultural", type: "all", eventId: 1 },
  { id: 67, src: "https://i.ibb.co/Syc3WSr/Faty.jpg", alt: "Cultural", type: "all", eventId: 1 },

  // Gam-Ind STUDENT WEEK (event id 2)
  { id: 16, src: "https://i.ibb.co/TBPNys4/indian-dance-manav.jpg", alt: "Student-Week", type: "portrait", eventId: 2 },
  { id: 17, src: "https://i.ibb.co/mcTzD49/gam-ind-ladies-manav.jpg", alt: "Student-Week", type: "portrait", eventId: 2 },

  // Gam-Ind GRADUATIONS CEREMONY (event id 3)
  { id: 31, src: "https://i.ibb.co/wzsrhdk/Gam-ind-grad-with-fift-presiden.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 33, src: "https://i.ibb.co/VD9tsVb/manav-highcom-Gam-ind.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 34, src: "https://i.ibb.co/jLv1WYm/depity-with-dawda.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 35, src: "https://i.ibb.co/WfMPQhJ/SW-02.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 36, src: "https://i.ibb.co/4gHf49b/SW-03.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 37, src: "https://i.ibb.co/SBwqjSQ/SW-04.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 38, src: "https://i.ibb.co/KhbSYwY/SW-05.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 39, src: "https://i.ibb.co/LhKt1QP/SW-06.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 40, src: "https://i.ibb.co/SJqDmn0/SW-20.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 41, src: "https://i.ibb.co/vht0kfY/SW-01.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 42, src: "https://i.ibb.co/58GdKzx/SW-09.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 43, src: "https://i.ibb.co/bmrnVZc/SW-19.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 44, src: "https://i.ibb.co/c8BycH4/SW-11.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 45, src: "https://i.ibb.co/JzsZVK7/SW-12.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 46, src: "https://i.ibb.co/8grpPSM/SW-13.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 47, src: "https://i.ibb.co/n0JsWRs/SW-14.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 48, src: "https://i.ibb.co/1Xb5Ymp/SW-15.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 49, src: "https://i.ibb.co/pPG0cps/SW-16.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 50, src: "https://i.ibb.co/HCL2KKp/SW-17.jpg", alt: "Graduation", type: "square", eventId: 3 },
  { id: 51, src: "https://i.ibb.co/php9mqB/SW-18.jpg", alt: "Graduation", type: "square", eventId: 3 },
  
  



  // SPORT (event id 4)
  { id: 47, src: "https://i.ibb.co/3CgbGvf/adama-sport.jpg", alt: "Sports photo", type: "sports", eventId: 4 },
  { id: 48, src: "https://i.ibb.co/rtWvpRX/ama-alpha-sport.jpg", alt: "Sports photo", type: "sports", eventId: 4 },
  { id: 49, src: "https://i.ibb.co/412fzFV/bass-sports.jpg", alt: "Sports photo", type: "sports", eventId: 4 },
  { id: 50, src: "https://i.ibb.co/Thc2BHP/dawda-sport.jpg", alt: "Sports photo", type: "sports", eventId: 4 },
  { id: 51, src: "https://i.ibb.co/8c0f9cj/daw-sport.jpg", alt: "Sports photo", type: "sports", eventId: 4 },
  { id: 52, src: "https://i.ibb.co/PY6HFBQ/dehi-sport.jpg", alt: "Sports photo", type: "sports", eventId: 4 },
  { id: 53, src: "https://i.ibb.co/gDYTfpD/ml-sport.jpg", alt: "Sports photo", type: "sports", eventId: 4 },
  { id: 54, src: "https://i.ibb.co/PY6HFBQ/dehi-sport.jpg", alt: "Sports photo", type: "sports", eventId: 4 },
  { id: 55, src: "https://i.ibb.co/ZNVg57y/physio-sports.jpg", alt: "Sports photo", type: "sports", eventId: 4 },
  { id: 56, src: "https://i.ibb.co/7r5khqs/sideby-sport.jpg", alt: "Sports photo", type: "sports", eventId: 4 },
  { id: 57, src: "https://i.ibb.co/y5xR05C/sis-sport.jpg", alt: "Sports photo", type: "sports", eventId: 4 },
  { id: 58, src: "https://i.ibb.co/2hdfmvG/sport-mav.jpg", alt: "Sports photo", type: "sports", eventId: 4 },
  { id: 59, src: "https://i.ibb.co/JxDWP7Y/symbayosis-sport.jpg", alt: "Sports photo", type: "sports", eventId: 4 },
  { id: 60, src: "https://i.ibb.co/kxqJgZC/sym-sport.jpg", alt: "Sports photo", type: "sports", eventId: 4 },

  // Trailblazers (event id 6)
  { id: 75, src: "https://i.ibb.co/nLhsxNM/manav-hanover.jpg", alt: "Trailblazers", type: "all", eventId: 6 },
  { id: 77, src: "https://i.ibb.co/6wrdcqx/gambia-rep-vizag.jpg", alt: "Trailblazers", type: "all", eventId: 6 },
  { id: 78, src: "https://i.ibb.co/XZpQvt6/adama-madam.jpg", alt: "Trailblazers", type: "all", eventId: 6 },
  { id: 80, src: "https://i.ibb.co/wWxtKvq/high-commisioner-with-adama.jpg", alt: "Trailblazers", type: "all", eventId: 6 },
  { id: 81, src: "https://i.ibb.co/zS6wFDs/IMG-4121.jpg", alt: "Trailblazers", type: "all", eventId: 6 },
  { id: 82, src: "https://i.ibb.co/4f9RYhy/SW-07.jpg", alt: "Trailblazers", type: "all", eventId: 6 },
  { id: 83, src: "https://i.ibb.co/Tw0ggfm/SW-08.jpg", alt: "Trailblazers", type: "all", eventId: 6 },
  { id: 84, src: "https://i.ibb.co/pXCZFmV/SW-10.jpg", alt: "Trailblazers", type: "all", eventId: 6 },
  



  // EXPLORATION (Event id 7)
  { id: 92, src: "https://i.ibb.co/6wrdcqx/gambia-rep-vizag.jpg", alt: "Explorers", type: "all", eventId: 7 },
  { id: 93, src: "https://i.ibb.co/XZpQvt6/adama-madam.jpg", alt: "Explorers", type: "all", eventId: 7 },
  { id: 94, src: "https://i.ibb.co/mzyGcYf/adamapress.jpg", alt: "Explorers", type: "all", eventId: 7 },
  { id: 95, src: "https://i.ibb.co/wWxtKvq/high-commisioner-with-adama.jpg", alt: "Explorers", type: "all", eventId: 7 },
];

const shuffleArray = (array) => {
  if (!Array.isArray(array) || array.length === 0) return [];
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const Gallery = () => {
  const [shuffledPhotos, setShuffledPhotos] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [modalImage, setModalImage] = useState(null);

  useEffect(() => {
    setShuffledPhotos(shuffleArray(photos));
  }, []);

  useEffect(() => {
    if (shuffledPhotos.length === 0) return;

    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % shuffledPhotos.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [shuffledPhotos]);

  const nextSlide = useCallback(() => {
    if (shuffledPhotos.length === 0) return;
    setCurrentIndex((prevIndex) => (prevIndex + 1) % shuffledPhotos.length);
  }, [shuffledPhotos]);

  const prevSlide = useCallback(() => {
    if (shuffledPhotos.length === 0) return;
    setCurrentIndex((prevIndex) => (prevIndex - 1 + shuffledPhotos.length) % shuffledPhotos.length);
  }, [shuffledPhotos]);

  const filterPhotosByEvent = useCallback((eventId) => {
    setSelectedEvent(eventId);
    const filteredPhotos = photos.filter(photo => photo.eventId === eventId);
    setShuffledPhotos(shuffleArray(filteredPhotos));
    setCurrentIndex(0);
  }, []);

  const openModal = (photo) => {
    if (photo) setModalImage(photo);
  };

  const closeModal = () => {
    setModalImage(null);
  };

  const SliderGallery = () => (
    <div className="relative w-full h-[50vh] md:h-[60vh] lg:h-[70vh] mb-8 bg-gray-100 rounded-lg overflow-hidden">
      {shuffledPhotos.length > 0 && shuffledPhotos[currentIndex] ? (
        <>
          <img
            src={shuffledPhotos[currentIndex].src}
            alt={shuffledPhotos[currentIndex].alt}
            className="w-full h-full object-contain cursor-pointer"
            onClick={() => openModal(shuffledPhotos[currentIndex])}
          />
          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 md:p-3 rounded-full hover:bg-opacity-75 transition-all duration-300"
            aria-label="Previous slide"
          >
            &#10094;
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 md:p-3 rounded-full hover:bg-opacity-75 transition-all duration-300"
            aria-label="Next slide"
          >
            &#10095;
          </button>
          <div className="absolute bottom-4 left-4 bg-black bg-opacity-50 text-white p-2 rounded">
            <p className="text-xs md:text-sm">{shuffledPhotos[currentIndex].alt}</p>
          </div>
        </>
      ) : (
        <div className="flex items-center justify-center h-full">
          <p className="text-gray-500">No images available</p>
        </div>
      )}
    </div>
  );

  const MasonryGallery = () => (
    <div className="columns-1 sm:columns-2 md:columns-3 lg:columns-4 gap-4">
      {shuffledPhotos.map((photo) => (
        <div key={photo.id} className="mb-4 break-inside-avoid group relative">
          <img
            src={photo.src}
            alt={photo.alt}
            className="w-full rounded-lg shadow-md group-hover:shadow-xl transition-shadow duration-300 cursor-pointer"
            onClick={() => openModal(photo)}
            loading="lazy"
          />
          <div className="absolute bottom-2 left-2 bg-black bg-opacity-50 text-white p-2 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <p className="text-xs md:text-sm">{photo.alt}</p>
          </div>
        </div>
      ))}
    </div>
  );

  const Modal = () => {
    if (!modalImage) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50" onClick={closeModal}>
        <div className="relative max-w-4xl max-h-[90vh] h-full w-full mx-4">
          <img
            src={modalImage.src}
            alt={modalImage.alt}
            className="w-full h-full object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
          <button
            className="absolute top-4 right-4 text-white bg-black bg-opacity-50 rounded-full p-2 hover:bg-opacity-75 transition-all duration-300"
            onClick={closeModal}
            aria-label="Close modal"
          >
            <X size={24} />
          </button>
          <div className="absolute bottom-4 left-4 bg-black bg-opacity-50 text-white p-2 rounded">
            <p className="text-xs md:text-sm">{modalImage.alt}</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container mx-auto px-4 py-8 mt-12">
      <h1 className="text-4xl font-bold text-center mb-2 text-indigo-700">Gam-Ind Events Gallery</h1>

      <div className="mb-8">
        <h2 className="text-xl md:text-2xl font-semibold mb-4 flex items-center justify-center">
          <Calendar className="mr-2" />Events
        </h2>
        <div className="flex flex-wrap justify-center gap-2">
          {events.map((event) => (
            <button
              key={event.id}
              onClick={() => filterPhotosByEvent(event.id)}
              className={`px-3 py-1 md:px-4 md:py-2 rounded-full text-sm md:text-base ${selectedEvent === event.id ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-800'} hover:bg-indigo-500 hover:text-white transition-colors duration-300`}
            >
              {event.name}
            </button>
          ))}
          <button
            onClick={() => {
              setSelectedEvent(null);
              setShuffledPhotos(shuffleArray(photos));
              setCurrentIndex(0);
            }}
            className="px-3 py-1 md:px-4 md:py-2 rounded-full text-sm md:text-base bg-gray-200 text-gray-800 hover:bg-indigo-500 hover:text-white transition-colors duration-300"
          >
            All Photos
          </button>
        </div>
      </div>
      <div className="bg-gray-100 border border-gray-300 rounded-lg p-4 mb-8 text-center">
        <p className="text-sm md:text-base text-gray-700">
          <strong>Copyright Notice:</strong> All photos in this gallery are subject to copyright.
          Unauthorized use, reproduction, or distribution is prohibited.
        </p>
      </div>
      <SliderGallery />
      <h2 className="text-xl md:text-2xl font-semibold mb-4 flex items-center justify-center">
        <Columns className="mr-2" /> Photo Gallery
      </h2>
      <MasonryGallery />
      <Modal />
    </div>
  );
};

export default Gallery;